import { connect } from 'react-redux';
import DisplayActions from '../../../../../redux/DisplayRedux';
import ScreensCollectionComponent from '../../components/step2_settings/ScreensCollectionComponent';

const mapStateToProps = ({ display, userAccount }) => ({
  cart: display.cart,
  managerDisplayFilter: display.managerDisplayFilter,
  managerDisplaySelector: display.managerDisplaySelector,
  disabledManagerDisplayFilter: display.disabledManagerDisplayFilter,
  programmatic: display.programmatic,
  customContents: display.customContents,
  currency: userAccount.currency,
  audience: display.audience,
  editCampaignActive: display.editCampaignActive,
  currentCampaign: display.currentCampaign,
  isPaymentStatusApproved: display.isPaymentStatusApproved,
  campaignCurrency: display.campaignCurrency,
  realAmount: display.realAmount,
  isSuperUser: userAccount.isSuperUser
});

const mapStateToDispatch = dispatch => ({
  disableManagerDisplayFilter: disabledManagerDisplayFilter =>
    dispatch(DisplayActions.disableManagerDisplayFilter(disabledManagerDisplayFilter)),
  updateCustomContents: customContents =>
    dispatch(DisplayActions.updateCustomContents(customContents)),
  toggleSecuredInvestment: (companyId, isSecured) =>
    dispatch(DisplayActions.toggleSecuredInvestment(companyId, isSecured))
});

export default connect(mapStateToProps, mapStateToDispatch)(ScreensCollectionComponent);
